// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2S2Ll","branding":"footer-module--branding--3kgLO","nav":"footer-module--nav--2JM1n"};